import { Link } from 'react-router-dom';

import { useNotice } from '../../stores/notice';

/** Mounted once in the shell; draws `useNotice`. Sits just above the dock. */
export function Notice() {
  const text = useNotice((s) => s.text);
  const to = useNotice((s) => s.to);
  const clear = useNotice((s) => s.clear);

  if (text === null) return null;

  const className =
    'pointer-events-auto rounded-[var(--radius-pill)] border border-line-lit bg-raised px-4 py-2 text-[13px] text-ink shadow-lg';

  return (
    <div
      role="status"
      data-notice
      className="pointer-events-none fixed inset-x-0 bottom-24 z-50 flex justify-center px-4"
    >
      {to ? (
        <Link to={to} onClick={clear} className={`${className} hover:border-fresh`}>
          {text}
        </Link>
      ) : (
        <div className={className}>{text}</div>
      )}
    </div>
  );
}
